import { Box } from "@mui/material";
import React, { Component } from "react";

export default class BreakpointTemplate extends Component<any> {
  static defaultProps = {
    disabledToBreakpoint: null,
    disabledMessage:
      "Please access Klayo on a wider screen to get access to this feature",
  };

  render() {
    const {
      theme,
      children,
      disabledToBreakpoint,
      disabledMessage,
      breakpoint,
      to,
      from,
      sx,
      forceTo,
    } = this.props;

    //Toggle mode
    if (theme && breakpoint && (to || from)) {
      return (
        <div style={sx}>
          <Box
            sx={{
              [theme.breakpoints.down(breakpoint)]: {
                display: "block",
              },
              [theme.breakpoints.up(breakpoint)]: {
                display: forceTo ? "block" : "none",
              },
            }}
          >
            {to}
          </Box>

          <Box
            sx={{
              [theme.breakpoints.down(breakpoint)]: {
                display: "none",
              },
              [theme.breakpoints.up(breakpoint)]: {
                display: forceTo ? "none" : "block",
              },
            }}
          >
            {from}
          </Box>
        </div>
      );
    }

    //Visible vs disabled mode
    else
      return !theme || !disabledToBreakpoint ? (
        children
      ) : (
        <div style={sx}>
          <Box
            sx={{
              [theme.breakpoints.down(disabledToBreakpoint)]: {
                display: "none",
              },
              [theme.breakpoints.up(disabledToBreakpoint)]: {
                display: "block",
              },
            }}
          >
            {children}
          </Box>

          <Box
            sx={{
              [theme.breakpoints.down(disabledToBreakpoint)]: {
                display: "block",
              },
              [theme.breakpoints.up(disabledToBreakpoint)]: {
                display: "none",
              },
            }}
          >
            {disabledMessage}
          </Box>
        </div>
      );
  }
}
